import React, { useState } from 'react';
import { Shield, CheckCircle, XCircle, Clock, ChevronDown, ChevronUp } from 'lucide-react';
import { format } from 'date-fns';

export default function RlsPolicyPanel({ logs }) {
  const [expandedLog, setExpandedLog] = useState(null);

  const getDecisionColor = (decision) => {
    return decision === 'allowed' ?'bg-green-100 text-green-800' :'bg-red-100 text-red-800';
  };

  const getDecisionIcon = (decision) => {
    return decision === 'allowed' ? CheckCircle : XCircle;
  };

  if (!logs || logs?.length === 0) {
    return (
      <div className="text-center py-12">
        <Shield className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-500">No RLS policy logs found for the selected filters</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {logs?.map((log) => {
        const DecisionIcon = getDecisionIcon(log?.decision);
        return (
          <div
            key={log?.id}
            className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-3 mb-2">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium flex items-center ${getDecisionColor(log?.decision)}`}>
                    <DecisionIcon className="w-3 h-3 mr-1" />
                    {log?.decision?.toUpperCase()}
                  </span>
                  <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
                    {log?.operation}
                  </span>
                  <span className="text-xs text-gray-500">
                    <Clock className="w-3 h-3 inline mr-1" />
                    {format(new Date(log?.createdAt), 'MMM dd, yyyy HH:mm:ss')}
                  </span>
                </div>
                <div className="mb-2">
                  <p className="text-sm text-gray-900 font-medium">
                    Policy: <span className="font-mono text-blue-600">{log?.policyName}</span>
                  </p>
                  <p className="text-sm text-gray-700">
                    Table: <span className="font-mono">{log?.tableName}</span>
                  </p>
                </div>
                {log?.user && (
                  <p className="text-xs text-gray-600">
                    User: {log?.user?.first_name} {log?.user?.last_name} ({log?.user?.email})
                  </p>
                )}
                {log?.reason && (
                  <p className="text-xs text-gray-600 mt-1">
                    Reason: {log?.reason}
                  </p>
                )}
                {log?.executionTimeMs && (
                  <p className="text-xs text-gray-500 mt-1">
                    Execution time: {log?.executionTimeMs}ms
                  </p>
                )}
              </div>
              <button
                onClick={() => setExpandedLog(expandedLog === log?.id ? null : log?.id)}
                className="ml-4 p-2 hover:bg-gray-100 rounded-lg"
              >
                {expandedLog === log?.id ? (
                  <ChevronUp className="w-5 h-5 text-gray-600" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-600" />
                )}
              </button>
            </div>

            {expandedLog === log?.id && log?.contextData && (
              <div className="mt-4 pt-4 border-t border-gray-200">
                <h4 className="text-xs font-semibold text-gray-700 mb-2">Context Data</h4>
                <pre className="bg-gray-50 p-3 rounded text-xs overflow-auto max-h-40">
                  {JSON.stringify(log?.contextData, null, 2)}
                </pre>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}